import { apiErrorMessage } from 'syft-acp-core/reducers/generators/utils'

export const entityFetchFailed = (state, action) => {
  return {
    ...state,
    lastMessage: apiErrorMessage(action.payload),
    isLoadingData: false,
  }
}
